import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "checked", "onChange"];
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox, Label, LayoutHorizontal, TooltipInfo } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverwriteSetting = _ref => {
  let {
      id,
      checked,
      onChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(LayoutHorizontal, Object.assign({}, rest, {
    flexWrap: "wrap",
    gapColumn: "space-xs",
    children: [/*#__PURE__*/_jsx(Checkbox, {
      "aria-label": I18n.text('overwrite.label'),
      checked: checked,
      id: id,
      onChange: onChange
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: id,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "overwrite.label"
      })
    }), /*#__PURE__*/_jsx(TooltipInfo, {
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "overwrite.description"
      })
    })]
  }));
};